/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import { Container } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import { object } from 'prop-types';
import mbpUtil from 'mbp-api-util';
import { loadYotpoSkeleton, loadYotpoImages, addLibraries } from '../../../../../helpers/commonFunctions';

const styles = () => ({
    yotpoCarousel: {
        paddingBottom: '3rem',
        paddingTop: '1rem',
        '& .yotpo-reviews-carousel': {
            '& .headline': {
                maxWidth: '65%',
            },
        },
    },
});

const YotpoReviewCarousel = ({ classes }) => {
    const [canRender, setRender] = useState(false);
    const APP_YOTPO_CLIENT_ID = mbpUtil.getEnv('APP_YOTPO_CLIENT_ID');
    const yotpoClientURL = `https://staticw2.yotpo.com/${APP_YOTPO_CLIENT_ID}/widget.js`;
    useEffect(() => {
        addLibraries(yotpoClientURL, '', false, true);
    }, []);

    useEffect(() => {
        if (typeof document !== 'undefined') {
            const timer = setTimeout(() => {
                setRender(true);
                if (document.querySelector('.yotpo-reviews-carousel')) {
                    loadYotpoImages();
                    loadYotpoSkeleton();
                }
                clearTimeout(timer);
            }, 2000);
        }
    }, [window.yotpo?.state]);
    return (
        <Container className={`customer-reviews yotpo-carousel ${classes.yotpoCarousel}`}>
            { !canRender ? <></> : (
                <div
                    className="yotpo yotpo-reviews-carousel"
                    data-background-color="transparent"
                    data-mode="top_rated"
                    data-type="site"
                    data-count="9"
                    data-autoplay-enabled="1"
                    data-autoplay-speed="3000"
                    data-show-navigation="1"
                >
                &nbsp;
                </div>
            )}
        </Container>
    );
};

YotpoReviewCarousel.propTypes = {
    classes: object.isRequired,
};

export default withStyles(styles)(YotpoReviewCarousel);
